'use client';

import DynamicScrollHeader from '@components/DynamicScrollHeader';
import { Box } from '@mui/material';
import DynamicLogo from '@components/DynamicLogo';
import CommonContainer from '@components/CommonContainer';
import DynamicButton from '@components/DynamicButton';
import DynamicDrawer from '@components/DynamicDrawer';
import WimbledonNavigation from './WimbledonNavigation';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import { ContactIcon } from '@components/SVGIcon/Icons';
import { LanguageDropdown } from '@components/LanguageDropdown';
import cn from './style.module.scss';
export default function WimbledonBridgeHeader(props: any) {
  const headerNavigation =
    props.locale.section?.wimbledonBridgeNavigation || [];
  return (
    <DynamicScrollHeader
      headerClassName={cn.wimbledonBridgeHeader}
      scrolledClassName={cn.wimbledonBridgeScroll}
    >
      <Box className={cn.wimbledonHeaderInner}>
        <CommonContainer
          maxWidth={{ xs: '100%', md: '1360px', lg: '1360px' }}
          flexGrow={1}
        >
          <Box className={cn.wimbledonHeaderBlock}>
            <Mobile>
              <Box className={cn.wimbledonHeaderNavigation}>
                <DynamicDrawer
                  drawerClassName={cn.wimbledonHeaderDrawer}
                  drawerBodyClassName={cn.wimbledonHeaderBody}
                  drawerContentClassName={cn.wimbledonHeaderContent}
                  closeBtnClassName={cn.wimbledonHeaderClose}
                  buttonClassName={cn.wimbledonHeaderHamburger}
                >
                  <WimbledonNavigation navigationItems={headerNavigation} />
                </DynamicDrawer>
              </Box>
            </Mobile>
            <Box className={cn.wimbledonHeaderLogo}>
              <Box className={cn.wimbledonLogoElement}>
                <DynamicLogo
                  logoImage={props?.images?.wimbledon_bridge_logo_dark?.src}
                  alt={'Wimbledon Bridge Logo'}
                />
              </Box>
            </Box>
            <Desktop>
              <Box className={cn.wimbledonHeaderNavigation}>
                <WimbledonNavigation navigationItems={headerNavigation} />
              </Box>
            </Desktop>
            <Box className={cn.wimbledonHeaderButton}>
              <DynamicButton
                className={cn.wimbledonHeaderButton__element}
                scrollToId="wimbledonBridgeRegistrationID"
              >
                <Mobile>
                  <span>
                    <ContactIcon />
                  </span>
                </Mobile>
                <Desktop>
                  {props.locale.section['wimbledonBridgeButton']}
                </Desktop>
              </DynamicButton>
              <Box className={cn.wimbledonHeaderButton__language}>
                <LanguageDropdown options={props.langOptions} variant="light" />
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </DynamicScrollHeader>
  );
}
